<div class="tw:w-full tw:m-0 tw:p-0">
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
        <div class="tw:flex-1 tw:px-[15px]">
            <div #bannerContainer>
            </div>
        </div>
    </div>
</div>